export const MapaPichi = () => {
  return (

    
    <iframe
        title="Puerto Pichilingue"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3636.9794795752364!2d-110.33031128768734!3d24.277447268245783!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x86afcd63f890f631%3A0x56a3c4ff0453303c!2sBaja%20Ferries%20Pichilingue!5e0!3m2!1ses!2smx!4v1700263523325!5m2!1ses!2smx&z=7"
        width="100%"
        height="100%"
        frameBorder="0"
        allowFullScreen
        zoom={5}


    />
  )
}
export default MapaPichi;



